import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../../context/LanguageContext';
export function Footer() {
  const {
    t,
    lang
  } = useLanguage();
  const medicalDisclaimer = lang === 'es' ? 'AVISO MÉDICO: Los resultados varían entre cada paciente. El Lipolaser es un procedimiento estético no quirúrgico y no es un tratamiento para la obesidad ni un sustituto de dieta y ejercicio. Toda candidatura es evaluada individualmente por el equipo médico. Las imágenes utilizadas representan casos reales con consentimiento expreso.' : 'MEDICAL DISCLAIMER: Individual results vary. Lipolaser is a non-surgical aesthetic procedure and is not a treatment for obesity nor a substitute for diet and exercise. All candidacy is evaluated individually by the medical team. Images depict actual patients shared with express consent.';
  return <footer className="bg-brand-dark text-brand-cream py-24 relative overflow-hidden" data-id="element-138">
      <div className="absolute inset-0 bg-grain opacity-50 pointer-events-none" data-id="element-139"></div>

      <div className="container mx-auto px-6 relative z-10" data-id="element-140">
        {/* Top: brand + tagline */}
        <div className="text-center max-w-2xl mx-auto mb-12" data-id="element-141">
          <a href="/" className="inline-flex flex-col items-center gap-2 mb-8" data-id="element-142">
            <span className="text-3xl font-serif font-light text-brand-cream" data-id="element-143">
              DermaLipo
            </span>
            <span className="text-[10px] font-medium tracking-[0.3em] uppercase text-brand-gold" data-id="element-144">
              Phoenix
            </span>
          </a>

          <p className="text-brand-cream/60 font-light italic font-serif mb-6" data-id="element-145">
            {t('footer.tagline')}
          </p>

          <div className="w-10 h-px bg-brand-gold/50 mx-auto" data-id="element-146"></div>
        </div>

        {/* Middle: navigation + legal links */}
        <div className="max-w-3xl mx-auto mb-16" data-id="element-147">
          <div className="flex flex-wrap justify-center gap-x-8 gap-y-4 mb-8" data-id="element-148">
            <a href="/#beneficios" className="text-[10px] font-medium tracking-widest uppercase text-brand-cream/50 hover:text-brand-cream transition-colors" data-id="element-149">
              {t('nav.benefits')}
            </a>
            <a href="/#proceso" className="text-[10px] font-medium tracking-widest uppercase text-brand-cream/50 hover:text-brand-cream transition-colors" data-id="element-150">
              {t('nav.process')}
            </a>
            <a href="/#doctor" className="text-[10px] font-medium tracking-widest uppercase text-brand-cream/50 hover:text-brand-cream transition-colors" data-id="element-151">
              {t('nav.doctor')}
            </a>
            <a href="/#testimonios" className="text-[10px] font-medium tracking-widest uppercase text-brand-cream/50 hover:text-brand-cream transition-colors" data-id="element-152">
              {t('nav.testimonials')}
            </a>
            <a href="/#faq" className="text-[10px] font-medium tracking-widest uppercase text-brand-cream/50 hover:text-brand-cream transition-colors" data-id="element-153">
              {t('nav.faq')}
            </a>
          </div>

          <div className="flex flex-wrap justify-center items-center gap-x-6 gap-y-3" data-id="element-154">
            <Link to="/privacy" className="text-[10px] font-medium tracking-widest uppercase text-brand-cream/40 hover:text-brand-cream/80 transition-colors" data-id="element-155">
              {t('footer.links.privacy')}
            </Link>
            <span className="text-brand-gold/30 text-[10px]" data-id="element-156">·</span>
            <Link to="/terms" className="text-[10px] font-medium tracking-widest uppercase text-brand-cream/40 hover:text-brand-cream/80 transition-colors" data-id="element-157">
              {t('footer.links.terms')}
            </Link>
            <span className="text-brand-gold/30 text-[10px]" data-id="element-158">·</span>
            <Link to="/disclaimer" className="text-[10px] font-medium tracking-widest uppercase text-brand-cream/40 hover:text-brand-cream/80 transition-colors" data-id="element-159">
              {lang === 'es' ? 'Aviso Médico' : 'Medical Disclaimer'}
            </Link>
          </div>
        </div>

        {/* Medical disclaimer block — visible & required */}
        <div className="max-w-4xl mx-auto pt-12 border-t border-brand-cream/10" data-id="element-160">
          <p className="text-[10px] text-brand-cream/40 font-light leading-relaxed text-center mb-8 tracking-wide" data-id="element-161">
            {medicalDisclaimer}
          </p>

          <p className="text-[10px] text-brand-cream/30 font-light leading-relaxed text-center max-w-2xl mx-auto mb-8 italic" data-id="element-162">
            {lang === 'es' ? 'DermaLipo Phoenix opera bajo las regulaciones del Estado de Arizona y cumple con HIPAA en el manejo de información médica protegida.' : 'DermaLipo Phoenix operates under Arizona State regulations and complies with HIPAA in the handling of protected health information.'}
          </p>

          <p className="text-brand-cream/30 text-[10px] font-medium tracking-widest uppercase text-center" data-id="element-163">
            {t('footer.rights')}
          </p>
        </div>
      </div>
    </footer>;
}